import { createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59bf8bc0")

_pushScopeId("data-v-59bf8bc0")
const _hoisted_1 = { class: "field__update" }
const _hoisted_2 = {
  class: "update__group",
  style: {"flex":"0 0 auto"}
}
const _hoisted_3 = { class: "update__title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Ajouter un terrain", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "update__item" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Nom du Terrain: ", -1)
const _hoisted_9 = { class: "update__item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Type de terrain: ", -1)
const _hoisted_11 = { class: "update__item" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "Lieu: ", -1)
const _hoisted_13 = {
  ref: "places",
  type: "text",
  tabindex: "0"
}
const _hoisted_14 = {
  key: 1,
  class: "icon-attention"
}
const _hoisted_15 = {
  ref: "fields",
  class: "update__group"
}
const _hoisted_16 = {
  class: "previewMap",
  ref: "preview"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: ["button button--action", {'button--disabled': !_ctx.fieldAddValid || !_ctx.validApiKeys}],
          tabindex: "0",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addField && _ctx.addField(...args)), ["enter"])),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addField && _ctx.addField(...args)))
        }, [
          _hoisted_4
        ], 34),
        _hoisted_5
      ]),
      (_ctx.validApiKeys)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addFieldName = $event)),
                tabindex: "0"
              }, null, 512), [
                [_vModelText, _ctx.addFieldName]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addFieldTypeSelected = $event)),
                tabindex: "0"
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fieldTypes, (type, ix) => {
                  return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(type), 1))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.addFieldTypeSelected]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("input", _hoisted_13, null, 512)
            ])
          ]))
        : (_openBlock(), _createBlock("i", _hoisted_14, "Erreur de chargement de Google Maps"))
    ]),
    _createVNode("div", _hoisted_15, [
      _withDirectives(_createVNode("div", _hoisted_16, null, 512), [
        [_vShow, _ctx.validApiKeys]
      ])
    ], 512)
  ]))
})